import * as React from "react";
import { Static } from "@bizform/type/decorator/Static.decorator";
import { ComponentElement, ComponentElementStatic } from "@bizform/type/model/component_element/ComponentElement.model";
import {
    ComponentCategory,
    ComponentElementManifest
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import { DataType } from "@bizform/type/model/model/DataType.model";
import { ComponentElementClass, ReactComponentElementInit } from "@bizform/core/dist/js/bizflow/core.min";
import { BfInputTextNumeric } from "./BfInputTextNumeric";
import { I18n } from "../../misc/model/I18n.model";


/**
 * @since 0.0.1
 * @author Hwansoon Park, modified Heungsoo Ham
 * @class BfCurrency
 * @description BfCurrency component element
 */
@ComponentElementClass()
@Static<ComponentElementStatic<number>>()
export class BfCurrency extends BfInputTextNumeric {
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_OE3urn6wKKcuhtlkSi2TFUJv6hWmfCm",
        category: ComponentCategory.INPUT,
        label: I18n.componentElement.currency.label,
        description: I18n.componentElement.currency.description,
        icon: "",
        dataType: [DataType.NUMBER],
        property: null
    };

    @ReactComponentElementInit(BfCurrency)
    static init(): ComponentElement<number> {
        return;
    }

    constructor(props?: any) {
        super(props);
    }
}
